// A diagram item type also stores the match confidence; any of the four changing is an LV edit.
export const DIAGRAM_LV_MATCH_COLUMNS = [
  "lvMatchId",
  "lvMatchName",
  "lvMatchConfidence",
  "lvMatchReasoning",
] as const;
